import { Grid, Typography, Box, Button, } from "@mui/material";
import LoginTabs from "./LoginTabs";
import GoogleImg from "../img/googleIcon.png"
import FacebookImg from "../img/facbookicon.png"
import DataIcon from "../img/dataicon.png"
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { AuthSocialLogin } from "../ReduxStore/authSlice";
import { useDispatch } from "react-redux";
import showToast from "../Utilities/showToast";
import { useNavigate } from "react-router-dom";

const Login = ({facebookClientId}) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    //const facebookClientId = '1179569787372214';
    const handleGoogleLogin = useGoogleLogin({
        onSuccess: async (response) => {
            try {
                const userInfo = await axios.get(
                    "https://www.googleapis.com/oauth2/v3/userinfo",
                    {
                        headers: { Authorization: `Bearer ${response.access_token}` },
                    }
                );
                const { payload: apiResponse } = await dispatch(AuthSocialLogin({
                    login_type: 1, email: userInfo.data.email, first_name: userInfo.data.given_name
                }))
                if (apiResponse?.status) {
                    showToast('success', apiResponse?.message)
                    navigate('/')

                } else {
                    showToast('error', apiResponse?.message)
                }

            } catch (error) {
                return error;
            }
        },
        onError: () => {
        return 1;
        },
    })

    const handleFacebookSuccess = async (response) => {
        const { payload: apiResponse } = await dispatch(AuthSocialLogin({
            login_type: 2, email: response.email, first_name: response.name
        }))
        if (apiResponse?.status) {
            showToast('success', apiResponse?.message)
            navigate('/')

        } else {
            showToast('error', apiResponse?.message)
        }
    }

   

    return (<>
        <Box>
            <LoginTabs />
            <Grid container spacing={2}>
                <Grid size={{ md: 12, xs: 12 }}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            gap: 1.5,
                        }}
                    >
                        <Box
                            sx={{
                                flex: 1,
                                height: "1px",
                                backgroundColor: "#e0e0e0",
                            }}
                        />
                        <Typography
                            sx={{
                                fontFamily: "Segoe UI",
                                fontSize: "14px",
                                fontWeight: "normal",
                                color: "#717182",
                                whiteSpace: "nowrap",
                            }}
                        >
                            Or continue with
                        </Typography>
                        <Box
                            sx={{
                                flex: 1,
                                height: "1px",
                                backgroundColor: "#e0e0e0",
                            }}
                        />
                    </Box>
                </Grid>
                <Grid size={{ md: 6, xs: 12 }}>
                    <Button
                        onClick={handleGoogleLogin}
                        variant="contained"
                        sx={{
                            padding: "10px",
                            borderRadius: "8px",
                            backgroundColor: "#f3f3f5",
                            fontFamily: "Segoe UI",
                            fontSize: "15px",
                            fontWeight: "normal",
                            textAlign: "center",
                            color: "#717182",
                            textTransform: "capitalize",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                            boxShadow: "none",
                            "&:hover": {
                                backgroundColor: "#e9e9eb",
                                boxShadow: "none",
                            },
                        }}
                    >
                        <Box
                            component="img"
                            src={GoogleImg}
                            alt="Google"
                            sx={{
                                width: 20,
                                height: 20,
                            }}
                        />
                        Google
                    </Button>
                </Grid>
                <Grid size={{ md: 6, xs: 12 }}>
                    <FacebookLogin
                        appId={facebookClientId}
                        autoLoad={false}
                        fields="name,email,picture"
                        scope="public_profile,email"
						callback={handleFacebookSuccess}
                        //onSuccess={handleFacebookSuccess}
                        //onFail={handleFacebookFailure}
                        render={({ onClick }) => (
                            <Button
                                onClick={onClick}
                                variant="contained"
                                sx={{
                                    padding: "10px",
                                    borderRadius: "8px",
                                    backgroundColor: "#f3f3f5",
                                    fontFamily: "Segoe UI",
                                    fontSize: "15px",
                                    fontWeight: "normal",
                                    textAlign: "center",
                                    color: "#717182",
                                    textTransform: "capitalize",
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "8px",
                                    boxShadow: "none",
                                    "&:hover": {
                                        backgroundColor: "#e9e9eb",
                                        boxShadow: "none",
                                    },
                                }}
                            >
                                <Box
                                    component="img"
                                    src={FacebookImg}
                                    alt="Google"
                                    sx={{
                                        width: 20,
                                        height: 20,
                                    }}
                                />
                                Facebook
                            </Button>)} />
                </Grid>
                <Grid size={{ md: 12, xs: 12 }}>
                    <Typography sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "15px",
                        fontWeight: "normal",
                        textAlign: "center",
                        color: "#717182",
                        textTransform: "capitalize",
                    }}><img src={DataIcon} alt="" /> Your data is secured with 256-bit encryption</Typography>
                </Grid>
            </Grid>
        </Box>

    </>)
}


export default Login;